import config from "@/config"
import store from "@/store"
import { msTimestampFormat } from "@/utils"

export enum VERSION_STATUS {
    未锁版 = 0,
    已经锁版,
    暂停发布
}

const STATUS_OPTIONS = [
    {
        label: "待锁版",
        value: 1
    },
    {
        label: "待发布",
        value: 2
    },
    {
        label: "全量",
        value: 3
    },
    {
        label: "灰度",
        value: 4
    },
    {
        label: "暂停发布",
        value: 5
    }
]
export const RECORD_NAME = [
    {
        label: "管理员调整记录",
        value: "管理员调整记录"
    },
    {
        label: "排期调整记录",
        value: "排期调整记录"
    },
    {
        label: "版本锁版记录",
        value: "版本锁版记录"
    }
]
export const Columns = [
    {
        title: "版本类型",
        dataIndex: "version_type",
        width: 100,
        filter: {
            type: "select",
            options: store.getters["common/version_type"]
        }
    },
    {
        title: "版本负责人",
        dataIndex: "version_owner",
        width: 100,
        filter: {
            type: "user",
            mode: 1
        },
        renderProps: {
            showPopover: true,
            platform_id: config.api.PID
        },
        renderType: "user"
    },
    {
        title: "发布状态",
        dataIndex: "release_status",
        width: 120,
        filter: {
            type: "select",
            options: STATUS_OPTIONS
        }
    },
    {
        title: "创建人",
        dataIndex: "create_user",
        renderType: "user",
        width: 90,
        renderProps: {
            showPopover: true,
            platform_id: config.api.PID
        }
    },
    {
        title: "锁版时间",
        dataIndex: "lock_time",
        sort: {},
        width: 120,
        filter: {
            type: "date"
        }
    },
    {
        title: "最新发布时间",
        dataIndex: "latest_release_time",
        width: 150,
        sort: {},
        filter: {
            type: "date"
        }
    },
    {
        title: "项目排期",
        dataIndex: "schedule",
        width: 150
    }
]
export const ScheduleNoticeList = [
    {
        label: "产品经理",
        value: "product_manager",
        span: 1
    },
    {
        label: "测试负责人",
        value: "test_leader",
        span: 1
    },
    {
        label: "技术负责人",
        value: "technical_director",
        span: 1
    },
    {
        label: "锁版人",
        value: "lock_version_user",
        span: 1
    },
    {
        label: "版本负责人",
        value: "version_owner",
        span: 1
    }
]
export const NoticeList = [
    {
        label: "产品经理",
        value: "product_manager",
        span: 1
    },
    {
        label: "测试",
        value: "tester",
        span: 1
    },
    {
        label: "产品经理负责人",
        value: "product_owner",
        span: 1
    },
    {
        label: "测试负责人",
        value: "test_leader",
        span: 1
    },
    {
        label: "技术",
        value: "technical_personnel",
        span: 1
    },
    {
        label: "锁版人",
        value: "lock_version_user",
        span: 1
    },
    {
        label: "技术负责人",
        value: "technical_director",
        span: 1
    },
    {
        label: "发布人",
        value: "release_people",
        span: 1
    },
    {
        label: "运营",
        value: "operating_personnel",
        span: 1
    },
    {
        label: "项目经理",
        value: "project_manager",
        span: 1
    },
    {
        label: "其他",
        value: "other_personnel",
        span: 1
    }
]

export const ReleaseColumns = [
    {
        title: "渠道名称",
        dataIndex: "channel_name",
        key: "channel_name"
    },
    {
        title: "发布版本",
        dataIndex: "version_name",
        key: "version_name"
    },
    {
        title: "发布状态",
        dataIndex: "release_status",
        key: "release_status"
    },
    {
        title: "发布人",
        dataIndex: "release_people",
        key: "release_people"
    },
    {
        title: "发布时间",
        dataIndex: "release_time",
        key: "release_time"
    }
]
export const ScheduleColumnsDetail = [
    {
        title: "记录名称",
        dataIndex: "record_name",
        filter: {
            type: "select",
            options: RECORD_NAME,
            mode: "multiple"
        },
        width: 200
    },
    {
        title: "操作人",
        dataIndex: "operate_user_uid",
        renderProps: {
            showPopover: true,
            platform_id: config.api.PID
        },
        renderType: "user",
        width: 100
    },
    {
        title: "操作时间",
        dataIndex: "operate_time",
        sort: {},
        width: 200,
        customRender: (text: number) => {
            return text ? msTimestampFormat(text, "YYYY-MM-DD HH:mm:ss") : "-"
        }
    },
    {
        title: "详情",
        dataIndex: "details",
        width: 400,
        scopedSlots: { customRender: "details_name" }
    }
]
